import { api } from '@/services/api';
import { useTenants } from '@/services/tenants/useTenants';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { PART_FINDER_ACTIVITY_QUERY_KEY } from '../part-finder-activity/query';
import { PART_FINDER_REPORTS_QUERY_KEY } from '../part-finder-reports/query';

export const useCreateReportFromPartImageCandidate = () => {
  const queryClient = useQueryClient();
  const { getTenantId } = useTenants();
  const tenantId = getTenantId();
  return useMutation({
    mutationFn: async ({ identificationId, niin }: { identificationId: string; niin: string }) => {
      const response = await api.tenants.createReportFromPartImageCandidate(tenantId, identificationId, { niin });
      return response.data.partFinderReport;
    },
    onSuccess: () => {
      queryClient.resetQueries({ queryKey: [PART_FINDER_REPORTS_QUERY_KEY], exact: false });
      queryClient.resetQueries({ queryKey: [PART_FINDER_ACTIVITY_QUERY_KEY], exact: false });
    },
  });
};
